// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"91":"2bceeeaa","453":"c92c05ba","952":"20f9eb97"}[chunkId] + ".chunk.js";
};